export function createMarkup(html: string) {
  return { __html: html };
}
